export var UniversNetworkWithNetwork;
(function (UniversNetworkWithNetwork) {
    let type;
    (function (type) {
        type["OWN"] = "own";
        type["COMPETITOR"] = "competitor";
        type["ATTRACTOR"] = "attractor";
        type["INFO"] = "info";
    })(type = UniversNetworkWithNetwork.type || (UniversNetworkWithNetwork.type = {}));
})(UniversNetworkWithNetwork || (UniversNetworkWithNetwork = {}));
